import { render, staticRenderFns } from "./addAttachmentModal.vue?vue&type=template&id=5b4676e0&"
import script from "./addAttachmentModal.vue?vue&type=script&lang=js&"
export * from "./addAttachmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports